const ANIMALS = ['salmon', 'octopus', 'dolphin', 'turtle'];

export function getAnimal(objectId) {
  const sum = objectId
    .split('')
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return ANIMALS[sum % ANIMALS.length];
}
